/**
 * Transform club hunt_stats.member_stats for the member-activity bar chart.
 */

export function formatMemberChartLabel(member) {
  const first = (member?.first_name || '').trim();
  const last = (member?.last_name || '').trim();
  if (first && last) {
    return `${first.charAt(0)}. ${last}`;
  }
  if (first) return first;
  if (last) return last;
  const username = (member?.username || '').trim();
  return username || 'Member';
}

export function buildMemberActivityChartData(memberStats = [], options = {}) {
  const { sortBy = 'hunts', limit } = options;
  const rows = (Array.isArray(memberStats) ? memberStats : [])
    .map((member) => ({
      name: formatMemberChartLabel(member),
      hunts: Number(member?.total_hunts) || 0,
      harvests: Number(member?.harvests) || 0
    }))
    .filter((row) => row.hunts > 0 || row.harvests > 0);

  rows.sort((a, b) => {
    if (sortBy === 'name') return a.name.localeCompare(b.name);
    return b.hunts - a.hunts || b.harvests - a.harvests || a.name.localeCompare(b.name);
  });

  if (typeof limit === 'number' && limit > 0) {
    return rows.slice(0, limit);
  }
  return rows;
}

export function memberActivityChartHeight(rowCount, options = {}) {
  const { min = 220, max = 480, rowPx = 32, padding = 56 } = options;
  if (!rowCount) return min;
  return Math.min(max, Math.max(min, rowCount * rowPx + padding));
}
